export type 備品在庫 = {
  備品在庫ID: number
  備品コード: string
  備品名: string
  サイズ: string
  単位: string
  ロット: string
  払出単価: number
  在庫数量: number
  在庫場所: string
  備考: string
  更新日時: string
}

export type 備品在庫受払履歴 = {
  受払履歴ID: number
  備品在庫ID: number
  受払日: string
  備品コード: string
  備品名: string
  サイズ: string
  単位: string
  ロット: string
  払出単価: number
  受払数量: number
  在庫場所: string
  備考: string
  受払区分ID: number
  受払区分コード: string
  受払区分名称1: string
  受払区分ソート番号: number
  乗務員ID: number
  社員ID: number
  社員コード: string
  社員氏名: string
  部所コード: string
  部所名: string
}
//#region [request]

/**
 * 備品在庫一覧取得(受払共用)
 */
export type TBihinzaikoListGetReq = {
  備品名?: string
  備品コード?: string
}

/**
 * 備品在庫履歴一覧取得
 * GET /bihinzaikorirekilist/
 */
export type TBihinzaikoRirekiListGetReq = {
  受払日From?: string
  受払日To?: string
  備品名?: string
  部所コード?: string
  乗務員氏名?: string
  受払区分?: string
}

/**
 * 登録(受入)
 */
export type TBihinzaikoRegisterPostReq = {
  受払日: string
  備品コード: string
  備品名: string
  サイズ: string
  単位: string
  ロット: string
  払出単価: number
  受入数量: number
  在庫場所: string
  備考: string
  受払区分: string
}

/**
 * 更新(受入)
 */
export type TBihinzaikoUkeireRegisterPutReq = {
  受払日: string
  備品コード: string
  備品名: string
  サイズ: string
  単位: string
  ロット: string
  払出単価: number
  在庫数量: number
  受入数量: number
  在庫場所: string
  備考: string
  更新日時: string
  受払区分: string
}

/**
 * 備品在庫（削除）
 */
export type TBihinzaikoDeleteReq = {
  更新日時: string
}

/**
 * 更新(払出)
 * ※ 払出は更新のみ
 */
export type TBihinzaikoHaraidasiRegisterPostReq = {
  受払日: string
  部所コード: string
  乗務員コード: string
  払出数量: number
  備考: string
  更新日時: string
}

//#endregion

//#region [response]

/**
 * 備品在庫一覧取得 レスポンス
 */
export type TBihinzaikoInfoGetRes = 備品在庫

/**
 * 備品在庫受払履歴 レスポンス
 */
export type TBihinzaikoRirekiInfoGetRes = 備品在庫受払履歴

//#endregion

//#region validation schema ⇒ https://ajv.js.org/

// const 品名マスタ = {

// }
export const 備品在庫管理 = {
  受入: "ukeirelist",
  払出: "haraidasilist",
} as const
//#endregion
